import { render, staticRenderFns } from "./DeletePhotosAlert.vue?vue&type=template&id=65f2639e"
import script from "./DeletePhotosAlert.vue?vue&type=script&lang=js"
export * from "./DeletePhotosAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports